module.exports = __webpack_public_path__ + "img/select-test-panel.9e6a8b31.svg";